import { render, staticRenderFns } from "./baseChats.vue?vue&type=template&id=12e7f683&"
import script from "./baseChats.vue?vue&type=script&lang=js&"
export * from "./baseChats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports